import axios from 'axios';
import serviceConfig from '@/service/config';
import { takeTokenHandle, trimHandle, ignoreViolationParamsHandle } from '@/service/interceptors/request';
import { httpStatusExceptionHandle, responseHandle } from '@/service/interceptors/response';
import JSONBig from 'json-bigint';

const JSONBigString = JSONBig({ storeAsString: true });

// 创建axios新实例
const axiosInst = axios.create({
  ...serviceConfig,
  transformResponse: [
    (data) => {
      try {
        return JSONBigString.parse(data);
      } catch (e) {
        return data;
      }
    }
  ]
});
axiosInst.interceptors.request.use(
  config => {
    takeTokenHandle(config);
    trimHandle(config);
    ignoreViolationParamsHandle(config);
    return config;
  },
  err => Promise.reject(err)
);

// 注入响应拦截器
axiosInst.interceptors.response.use(
  resp => responseHandle(resp),
  err => httpStatusExceptionHandle(err)
);

export default ({
  install: Vue =>
    Vue.prototype.$http = function (method, url, data, isBlob = false, showErrorMsg = true) {
      if (method === 'get') {
        if (isBlob) {
          data = {
            params: data,
            responseType: 'blob'
          };
        } else {
          data = {
            params: data,
            paramsSerializer: function (params) {
              const keys = Object.keys(params)
              let arr = []
              keys.forEach(item => {
                if (Array.isArray(params[item])) {
                  const url = params[item].map(p => `${item}=${p}`).join('&')
                  arr.push(url)
                } else {
                  arr.push(`${item}=${params[item]}`)
                }
              })
              return arr.join('&')
            }
          };
        }
        const prom = axiosInst.get(url, data);
        prom.catch(err => {
          console.log('err:', err)
          if (err.indexOf('登录过期') >= 0 || err.indexOf('没有登录') >= 0 || err.indexOf('未授权') >= 0) {
            localStorage.setItem('TOKEN', '')
            localStorage.setItem('ACCOUNT_DTO', '')
            return this.$router.push('/login');
          }
          if (showErrorMsg) {
            this.$message.error(err);
          }
        });
        return prom;
      } else if (method == 'delete') {
        let prom = axiosInst.delete(url, { data });
        prom.catch(err => {
          if (err.indexOf('登录过期') >= 0 || err.indexOf('没有登录') >= 0 || err.indexOf('未授权') >= 0) {
            localStorage.setItem('TOKEN', '')
            localStorage.setItem('ACCOUNT_DTO', '')
            return this.$router.push('/login');
          }
          if (showErrorMsg) {
            this.$message.error(err);
          }
        });
        return prom;
      } else if (method == 'post') {
        let prom;
        if (isBlob) {
          prom = axiosInst.post(url, data, {
            'responseType': 'blob'
          });
        } else if (data instanceof FormData) {
          prom = axiosInst.post(url, data, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          });
        } else {
          prom = axiosInst.post(url, data);
        }
        prom.catch(err => {
          if (typeof err === 'object' && err) {
            err = err.errMsg
          }
          if (err.indexOf('登录过期') >= 0 || err.indexOf('没有登录') >= 0 || err.indexOf('未授权') >= 0) {
            localStorage.setItem('TOKEN', '')
            localStorage.setItem('ACCOUNT_DTO', '')
            return this.$router.push('/login');
          }
          if (showErrorMsg) {
            this.$message.error(err);
          }
        });
        return prom;
      }
    }
});
